import Constant from '@/const';
import axios from 'axios';

const getInitialObjectiveData = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/inpatient/cppt/autofill/${id}`),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getInitialObjectiveData;
